import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
  emailStatisticDetail: state => state.emailStatisticDetail,
  emailStatisticDetailInfo: state => state.emailStatisticDetailInfo,
  emailStatisticGroup: state => state.emailStatisticGroup,
  emailGroupBy: state => state.emailGroupings.emailGroup,
  emailGroupByOptionally: state => state.emailGroupings.emailGroupOptionally,
  emailEventsGroupByOptionally: state => state.emailGroupings.emailEventsGroupOptionally,
  eventTypeList: state => state.eventTypeList,
};